module.exports = __webpack_public_path__ + "img/unblock_icon.a39682eb.png";